<template>
  <section class="product">
    <div class="product__photo">
      <div class="photo-container">
        <div class="photo-main">
          <div class="controls"></div>
          <Courosel :images="RoomImages" />
        </div>
      </div>
    </div>
    <div class="product__info">
      <div class="title">
        <h1>{{ Room.name }}</h1>

        <div>
          <h3>Room Types</h3>

          <ul>
            <li v-for="item in RoomTypes">
              <a class="tag">{{ item.room_type.name }}</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="variant"></div>
      <div class="description">
        <h3>Room Details</h3>
        <ul>
          <li v-if="Room.remarks">{{ Room.remarks }}</li>
          <li>Smoking is {{ Room.is_smoking ? "Allowed" : "Not Allowed" }}</li>
          <li>This is {{ Room.floor.name }}</li>
          <li>Room Phone Number {{ Room.phone_expression }}</li>
        </ul>
      </div>
      <button
        class="buy--btn"
        @click="$router.push('/rooms-booking/'), addRoom()"
      >
        Book Now
      </button>
    </div>
  </section>
</template>

<script>
import Courosel from "@/components/base/Caurosel/index";
import { mapState } from "vuex";
import axios from "@/plugins/axios";
export default {
  data() {
    return {
      RoomImages: [],
    };
  },
  props: {
    Room: {
      type: Object,
      default: {},
    },

    RoomImages: {
      type: Array,
      default: [],
    },

    RoomTypes: {
      type: Array,
      default: [],
    },
  },
  components: {
    Courosel,
  },
  computed: {
    ...mapState("orders", ["FilterDate"]),
  },

  methods: {
    //Store the Room In State
    addRoom() {
      let credential = this.Room;
      credential.datefilter = this.FilterDate;
      credential.RoomImages = this.RoomImages;
      this.$store.commit("orders/addOrders", credential);
    },
  },
};
</script>
<style lang="scss" scoped>
/* ----- Variables ----- */
$color-primary: #4c4c4c;
$color-secondary: #a6a6a6;
$color-highlight: #ff3f40;

/* ----- Global ----- */

h3 {
  font-size: 0.7em;
  letter-spacing: 1.2px;
  color: $color-secondary;
}

img {
  max-width: 100%;
  filter: drop-shadow(1px 1px 3px $color-secondary);
}

/* ----- Product Section ----- */
.product {
  display: grid;
  grid-template-columns: 0.9fr 1fr;
  margin: auto;
  padding: 2.5em 0;
  min-width: 600px;
  background-color: white;
  border-radius: 5px;
}

/* ----- Photo Section ----- */
.product__photo {
  position: relative;
}

.photo-container {
  position: absolute;
  left: -2.5em;
  display: grid;
  grid-template-rows: 1fr;
  width: 100%;
  height: 100%;
  border-radius: 6px;
  box-shadow: 4px 4px 25px -2px rgba(0, 0, 0, 0.3);
}

.photo-main {
  border-radius: 12px;
  background-color: #9be010;
  background: radial-gradient(#e5f89e, #96e001);

  .controls {
    display: flex;
    justify-content: space-between;
    padding: 0.8em;
    color: #fff;

    i {
      cursor: pointer;
    }
  }

  img {
    position: absolute;
    left: -3.5em;
    top: 2em;
    max-width: 100%;
    filter: saturate(150%) contrast(120%) hue-rotate(10deg)
      drop-shadow(1px 20px 10px rgba(0, 0, 0, 0.3));
  }
}

.photo-album {
  padding: 0.7em 1em;
  border-radius: 0 0 6px 6px;
  background-color: #fff;

  ul {
    display: flex;
    justify-content: space-around;
  }

  li {
    float: left;
    width: 55px;
    height: 55px;
    padding: 7px;
    border: 1px solid $color-secondary;
    border-radius: 3px;
  }
}

/* ----- Informations Section ----- */
.product__info {
  padding: 0.8em 0;
}

.title {
  h1 {
    margin-bottom: 0.1em;
    color: $color-primary;
    font-size: 1.5em;
    font-weight: 900;
  }

  span {
    font-size: 0.7em;
    color: $color-secondary;
  }
}

.price {
  margin: 1.5em 0;
  color: $color-highlight;
  font-size: 1.2em;

  span {
    padding-left: 0.15em;
    font-size: 2.9em;
  }
}

.variant {
  overflow: auto;

  h3 {
    margin-bottom: 1.1em;
  }

  li {
    float: left;
    width: 35px;
    height: 35px;
    padding: 3px;
    border: 1px solid transparent;
    border-radius: 3px;
    cursor: pointer;

    &:first-child,
    &:hover {
      border: 1px solid $color-secondary;
    }
  }

  li:not(:first-child) {
    margin-left: 0.1em;
  }
}

.description {
  clear: left;
  h3 {
    margin-bottom: 1em;
    padding-left: 80px;
  }

  ul {
    text-align: left !important;
    font-size: 0.8em;
    padding-left: 80px;
  }

  li {
    list-style: disc;
    text-indent: -0.6em;
    margin-bottom: 0.5em;
  }
}

.buy--btn {
  padding: 1.5em 3.1em;
  border: none;
  border-radius: 7px;
  font-size: 0.8em;
  font-weight: 700;
  letter-spacing: 1.3px;
  color: #fff;
  background-color: $color-highlight;
  box-shadow: 2px 2px 25px -7px $color-primary;
  cursor: pointer;

  &:active {
    transform: scale(0.97);
  }
}

.description,
.description {
  width: 380px;
  word-break: break-all;
  /* padding: 0px 10px; */
}
</style>

<style scoped>
.product__info ul li {
  display: contents;
}
.owl-carousel.owl-drag .owl-item {
  height: 700px !important;
}

.owl-carousel .owl-item img {
  height: 700px !important;
}

.title h1[data-v-51ad3f8b] {
  font-size: 2.5em;
}
.photo-main {
  padding: 0px 20px;
}
.photo-main img[data-v-51ad3f8b] {
  position: absolute;
  left: 0em;
  top: 2em;
  padding: 10px;
  height: 508px;
  max-width: 101%;
}
.title span[data-v-51ad3f8b] {
  font-size: 1em;
  color: #a6a6a6;
}

h3[data-v-51ad3f8b] {
  font-size: 1.2em;
}

.description ul[data-v-51ad3f8b] {
  font-size: 0.9em;
}
.buy--btn[data-v-51ad3f8b] {
  font-size: 1em;
}

.photo-container[data-v-51ad3f8b] {
  left: -6.5em;

  height: 350px;
}

.title h1[data-v-51ad3f8b][data-v-51ad3f8b] {
  font-size: 2.5em;
  font-family: "Poppins";
}
</style>
